<template>
  <ui-modal v-model="isVisible">
    <div class="transfer-modal">
      <div class="title">
        {{ $t('attention') }}
        <div class="close" @click="closeHandler">
          <IconClearGray />
        </div>
      </div>
      <div class="main">
        {{ $t(props.options.message) }}
        <p>{{ $t(props.options.message_sub) }}</p>
      </div>
      <div class="actions">
        <DownloadLauncherButton
          :add-version-to-label="false"
          :isSeeSize="false"
        />
        <UiButton
          v-if="props.options.callback"
          color="grey"
          :label="$t(props.options.secondBtn)"
          @click="props.options.callback()"
        />
      </div>
    </div>
  </ui-modal>
</template>
<script setup lang="ts">
import IconClearGray from '~/assets/svg/close_gray.svg';
interface Options {
  options: {
    callback?: () => void;
    message: string;
    message_sub: string;
    mainBtn: string;
    secondBtn: string;
  };
}
const props = defineProps<Options>();
const closeHandler = () => {
  isVisible.value = false;
};
const isVisible = ref(false);
const open = () => {
  isVisible.value = true;
};

defineExpose({
  open,
  isVisible,
  closeHandler,
});
</script>

<style lang="scss" scoped>
.transfer-modal {
  width: 512px;
  min-height: 196px;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--white-theme-black-200, #64686e);
  background: var(--white-theme-white-100, var(--var-white-100));
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 550px) {
    width: 320px;
  }
  .title {
    position: relative;
    color: var(--white-theme-black-100, #3d424a);
    font-family: Segoe UI;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
    letter-spacing: 0.36px;
    .close {
      position: absolute;
      width: 20px;
      height: 20px;
      right: -16.001px;
      top: -16px;
      cursor: pointer;
    }
  }
  .main {
    width: 94%;
    color: var(--white-theme-black-100, #3d424a);
    font-family: Segoe UI;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 22.4px */
    letter-spacing: 0.48px;
    .link {
      color: var(--white-theme-blue-100, #2491e7);
      text-decoration: none;
    }
    @media (max-width: 550px) {
      width: 100%;
    }
  }
  .actions {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    button {
      width: 46%;
    }
    .main-btn {
      margin-left: auto;
    }
    @media (max-width: 550px) {
      flex-direction: column;
      button {
        width: 100%;
        margin-bottom: 20px;
        &:not(:first-child) {
          margin-bottom: 0px;
        }
      }
    }
  }
}
</style>
